import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";

const HoroscopoDragon = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Dragón - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Dragón. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Dragón." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="text-7xl mb-4">🐉</div>
              <h1 className="text-3xl font-bold mb-2">Dragón</h1>
              <p className="text-muted-foreground">Años: 1928, 1940, 1952, 1964, 1976, 1988, 2000, 2012, 2024</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu carisma legendario está en su máximo esplendor hoy, Dragón. Tu presencia magnética cautivará corazones. Las parejas experimentarán momentos de gran intensidad emocional y pasión renovada.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Hoy es tu día para brillar profesionalmente. Tu visión y ambición te llevarán a tomar decisiones importantes. El éxito está al alcance de tu mano, y tu liderazgo inspirará a otros.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía vital es poderosa. Canalízala sabiamente en actividades productivas. Aunque tu resistencia es notable, no descuides el descanso que tu cuerpo necesita para mantenerse en óptimas condiciones.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será memorable en el amor. Tu generosidad y nobleza tocarán corazones. Es momento perfecto para grandes gestos románticos. Los solteros atraerán admiradores con su magnetismo natural.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Oportunidades doradas se presentarán mañana. Tu confianza y habilidad para pensar en grande abrirán puertas importantes. Confía en tu intuición para tomar decisiones audaces.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu vitalidad estará excepcional. Es un día excelente para actividades físicas desafiantes o comenzar nuevos regímenes de salud. Tu determinación te llevará al éxito.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana extraordinaria en el amor te aguarda. Tu presencia imponente pero cálida creará conexiones profundas. Las relaciones alcanzarán nuevos niveles de compromiso e intensidad.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana serás imparable profesionalmente. Tu visión ambiciosa y capacidad de ejecución te llevarán a logros significativos. Reconocimiento y éxito están asegurados.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu energía legendaria equilibrada. Tu naturaleza poderosa necesita momentos de recarga. Combina actividad intensa con descanso adecuado para mantener tu rendimiento óptimo.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoDragon;
